t = require('app/scripts/views/internal/recup-with-helpers')('credit_card')

module.exports = BillingFormUtil =

  localizeCountry: ([value, key]) -> [value, t.l(['countries', key])]

  getCvvErrorKey: (cardType) ->
    if cardType == 'american-express'
      'please-enter-a-valid-4-digit-amex-cid'
    else
      'please-enter-a-valid-3-digit-cvv'

  unsupportedCardTypes: ['maestro']

  isUnsupportedCardType: (cardType) ->
    cardType in @unsupportedCardTypes

  getCardErrorFormatter: (cardType, niceCardType) ->
    if @isUnsupportedCardType(cardType)
      -> t.format 'unsupported-credit-card-type', niceCardType: niceCardType
    else
      -> t.format 'please-provide-your-full-card-number-for-credit-card-verification'

  getErrorField: (errorType) ->
    switch errorType
      when 'SHOP_INVALID_TAX_ZIP_CODE' then 'zipCode'
      when 'SHOP_INVALID_TAX_COUNTRY_CODE' then 'country'
      when 'SHOP_INVALID_TAX_ID' then 'taxId'
      when 'SHOP_UNSUPPORTED_CARD_TYPE' then 'number'
